import DuplicateTable from "./DuplicateTable";
import { useDuplicateTable } from "./useDuplicateTable";
import { DuplicateDetailPane } from "./DuplicateDetailPane";
export default DuplicateTable;
export { useDuplicateTable, DuplicateDetailPane };
